import {
  HOVER_MOUSE_ENTER,
  HOVER_MOUSE_LEAVE
} from '../constants/hover-vertical-types'

export const isHoverActive = mouseHover => {
  return dispatch => {
    dispatch({
      type: HOVER_MOUSE_ENTER,
      payload: mouseHover
    })
  }
}

export const isntHoverActive = mouseHover => {
  return dispatch => {
    dispatch({
      type: HOVER_MOUSE_LEAVE,
      payload: mouseHover
    })
  }
}